module.exports = __webpack_public_path__ + "static/media/KZ.5e68452f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KZ.svg
// module id = 295
// module chunks = 0